import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { NotificationComponent } from '@fcom/ui-components/components/notifications/notification/notification.component';

import { PipesModule } from '../../pipes/pipes.module';
import { ToasterService } from '../../services/toaster/toaster.service';
import { ComponentsModule } from '../components.module';
import { ToasterComponent } from './toaster.component';

@NgModule({
  imports: [CommonModule, PipesModule, ComponentsModule, UiTranslateModule, NotificationComponent],
  declarations: [ToasterComponent],
  exports: [ToasterComponent],
  providers: [ToasterService],
})
export class ToasterModule {}
